var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column-content-tab",class:{activiated:_vm.activiated}},[_c('button',{on:{"click":function($event){return _vm.onclick()}}},[_vm._v(" "+_vm._s(_vm.textLabel ? _vm.textLabel : _vm.$t('沿革'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }